import { globalSettingModel } from '@models/global-setting.model';
import { useModel } from 'foca';
import { type FC } from 'react';
import styles from './setting-preferred-explorer.module.scss';
import DownIcon from '@assets/images/header/down.svg';
import { startCase } from 'lodash-es';
import SettingPreferredExplorerContent from './setting-preferred-explorer-content';
import { useToggle } from 'react-use';
import Dropdown from '@ui/parrot/dropdown';

interface OwnProps {}

const SettingPreferredExplorer: FC<OwnProps> = () => {
  const explorerKey = useModel(globalSettingModel, (state) => state.explorerKey);
  const [visible, toggleVisible] = useToggle(false);

  return (
    <div className={styles.line}>
      <div className={styles.left}>Preferred Explorer</div>
      <Dropdown
        onOpenChange={toggleVisible}
        trigger={['click']}
        placement="bottomRight"
        dropdownRender={() => <SettingPreferredExplorerContent toggleSelecting={toggleVisible} />}
        open={visible}
      >
        <div className={`${styles.right} ${visible ? styles.active : ''}`}>
          <span>{startCase(explorerKey)}</span>
          <img src={DownIcon} />
        </div>
      </Dropdown>
    </div>
  );
};

export default SettingPreferredExplorer;
